import { BUSINESS } from "@/lib/sleek";

const UPDATED = "June 2026";

const SECTIONS = [
  {
    h: "Information we collect",
    p: "When you use our website, customer portal, or iOS app, we may collect: contact details you provide (name, email address, phone number, project address), project information (photos, notes, estimates, appointment requests, messages), and basic technical data (device type, browser, and analytics about how the site is used, including advertising click identifiers such as Google Ads gclid).",
  },
  {
    h: "How we use your information",
    p: "We use your information to respond to inquiries, prepare quotes, schedule consultations, manage your remodeling project, send service emails (such as appointment confirmations and reminders), and improve our website and marketing. We do not sell or rent your personal information to anyone.",
  },
  {
    h: "Sharing",
    p: "We share information only with service providers who help us operate — such as our email delivery provider, website hosting, analytics, and our customer relationship system — and only as needed to serve you. These providers are not permitted to use your information for their own purposes. We may disclose information if required by law.",
  },
  {
    h: "Data retention & security",
    p: "We keep project records for as long as needed to serve you and to meet legal and warranty obligations. Access to your information is limited to our team, protected by authentication, and transmitted over encrypted connections (HTTPS).",
  },
  {
    h: "Your choices & rights",
    p: "You may request a copy of the personal information we hold about you, ask us to correct it, or ask us to delete it (subject to legal record-keeping requirements). To make a request, contact us using the details below and we will respond within 30 days.",
  },
  {
    h: "Children",
    p: "Our services are intended for homeowners and adults. We do not knowingly collect personal information from children under 13.",
  },
  {
    h: "Changes to this policy",
    p: "If we make material changes to this policy, we will update this page and revise the date above.",
  },
];

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 md:py-24" data-testid="privacy-page">
      <div className="text-xs tracking-[0.3em] uppercase text-zinc-500">Legal</div>
      <h1 className="font-display text-5xl md:text-6xl font-light tracking-tight mt-4 leading-[1.05]">Privacy Policy</h1>
      <p className="text-zinc-500 text-sm mt-4">Last updated: {UPDATED}</p>
      <p className="text-zinc-600 mt-8 leading-relaxed">
        This policy describes how {BUSINESS.remodel} and {BUSINESS.showroom} ("we", "us") collect, use, and protect
        your information when you use our website, customer portal, and iOS app.
      </p>

      {SECTIONS.map((s) => (
        <div key={s.h} className="mt-10">
          <h2 className="font-display text-2xl">{s.h}</h2>
          <p className="text-zinc-600 mt-3 leading-relaxed text-sm md:text-base">{s.p}</p>
        </div>
      ))}

      <div className="mt-12 border border-zinc-200 p-6" data-testid="privacy-contact">
        <h2 className="font-display text-2xl">Contact us about privacy</h2>
        <p className="text-zinc-600 mt-3 leading-relaxed text-sm md:text-base">
          {BUSINESS.remodel} · {BUSINESS.address}
          <br />
          Email: <a href={BUSINESS.emailHref} className="underline hover:text-zinc-950">{BUSINESS.email}</a>
          <br />
          Phone: <a href={BUSINESS.phoneHref} className="underline hover:text-zinc-950">{BUSINESS.phone}</a>
        </p>
      </div>
    </div>
  );
}
